/* eslint-disable */
export const cashIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="  tColor" class="bi bi-coin" viewBox="0 0 16 16">' +
  '<path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518z"/>' +
  '<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>' +
  '<path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/>' +
  "</svg>";

export const shippingIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-truck" viewBox="0 0 16 16">' +
  '<path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>' +
  "</svg>";

export const giftIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-gift-fill" viewBox="0 0 16 16">' +
  '<path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A3 3 0 0 1 3 2.506zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43zM9 3h2.932l.023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0zm6 4v7.5a1.5 1.5 0 0 1-1.5 1.5H9V7zM2.5 16A1.5 1.5 0 0 1 1 14.5V7h6v9z"/>' +
  "</svg>";

export const percentageIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-percent" viewBox="0 0 16 16">' +
  '<path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>' +
  "</svg>";

export const exclamationIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill=#D74532 class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">' +
  '<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>' +
  "</svg>";

export const editIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" style="width: 15px">' +
  '<path d="M15.5325 5.28004C15.825 4.98754 15.825 4.50004 15.5325 4.22254L13.7775 2.46754C13.5 2.17504 13.0125 2.17504 12.72 2.46754L11.34 3.84004L14.1525 6.65254M2.25 12.9375V15.75H5.0625L13.3575 7.44754L10.545 4.63504L2.25 12.9375Z" fill="#1F1F1F"/>' +
  "</svg>";

export const ecommerceLabels = [
  { value: "shopify", text: "Shopify", imgSrc: "shopify.svg" },
  { value: "magento", text: "Magento", imgSrc: "magento.svg" },
];

export function titleCase(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.replace(word[0], word[0].toUpperCase());
    })
    .join(" ");
}
/* eslint-enable */
export function currencyFormat(amount) {
  let formattedCurrency = amount.toString();
  formattedCurrency = formattedCurrency.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return formattedCurrency;
}

export function numericalFormat(input) {
  let formattedNumber = input.toString();
  formattedNumber = formattedNumber.replace(/\D/g, "");
  formattedNumber = formattedNumber.replace(/^0+/, "");
  return formattedNumber;
}
